import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image1 from "../assets/cocopeat23.webp";
import image2 from "../assets/bannercoco1.png";
import image3 from "../assets/plant2.jpeg";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const BannerCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: false, // Keeps a consistent height
    dotsClass: "slick-dots custom-dots",
    responsive: [
      {
        breakpoint: 1024,
        settings: { dots: true },
      },
      {
        breakpoint: 600,
        settings: { dots: true },
      },
    ],
  };

  const slides = [
    {
      title: "Leading Coco Peat Exporters in India",
      subtitle: "SINCE 2015",
      button: "Get Started Now",
      link: "/products",
      image: image1,
      alt: "High-quality coco peat exporter in India - Tirumala Cocopeat",
    },
    {
      title: "High-Quality Products for All Your Needs",
      subtitle: "SUSTAINABLE AND RELIABLE",
      button: "Learn More",
      link: "/products",
      image: image2,
      alt: "Cocopeat products for innovative agricultural solutions",
    },
    {
      title: "Innovative Solutions for Agriculture",
      subtitle: "GROW WITH US",
      button: "Contact Us",
      link: "/contact",
      image: image3,
      alt: "Sustainable coco coir products for agriculture and horticulture",
    },
  ];

  return (
    <div className="relative w-full overflow-hidden z-10">

      <Helmet>
        <title>Tirumala Cocopeat | High-Quality Coco Peat & Coir Products</title>
        <meta
          name="description"
          content="Tirumala Cocopeat is a leading supplier of high-quality Coco Peat and Coir Products in India. Exporting sustainable coconut-based growing mediums worldwide."
        />
        <meta
          name="keywords"
          content="Tirumala Cocopeat, Coco Peat Exporters India, Coir Products Supplier, Coconut Fiber, Coir Grow Bags, Cocopeat Bricks, Hydroponic Coir, Coir Mats, Sustainable Growing Medium, Agriculture Cocopeat, Best Coco Peat for Horticulture, Organic Coco Coir, Soil Conditioning Cocopeat, Indian Coir Industry, High-Quality Cocopeat Supplier"
        />
        <meta name="author" content="Tirumala Cocopeat" />
        <meta name="robots" content="index, follow" />
        <meta name="og:title" content="Tirumala Cocopeat - Premium Coco Peat & Coir Suppliers" />
        <meta name="og:description" content="Explore high-quality and sustainable Coco Peat and Coir products for agriculture, horticulture, and industrial applications." />
        <meta name="og:type" content="website" />
        <meta name="og:url" content="https://tirumalacocopeat.vercel.app" />
        <meta name="og:image" content="https://tirumalacocopeat.vercel.app/assets/cocopeat23.webp" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tirumala Cocopeat - Best Coco Coir Exporters" />
        <meta name="twitter:description" content="Leading supplier of Coco Peat, Coir Grow Bags, and Hydroponic Coconut Fiber solutions worldwide." />
      </Helmet>

      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="relative w-full min-h-[500px] md:min-h-[600px] lg:min-h-[100vh]">
            {/* Background Image */}
            <div
              className="absolute inset-0 w-full h-full bg-cover bg-center"
              style={{
                backgroundImage: `url(${slide.image})`,
              }}
            ></div>
            {/* Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-40"></div>

            {/* Content */}
            <div className="absolute inset-0 flex items-center justify-center md:justify-start">
              <div className="lg:w-2/5 p-6 md:p-8 lg:p-12 text-center md:text-left space-y-3">
                <h3 className="text-gray-300 text-xs md:text-sm uppercase tracking-widest">
                  {slide.subtitle}
                </h3>
                <h2 className="text-white text-xl md:text-2xl lg:text-4xl font-bold">
                  {slide.title}
                </h2>
                <br/>
                <Link to={slide.link}>
                <button className="bg-green-500 hover:bg-green-600 text-white py-2 px-6 rounded-md transition-all text-base">
                  {slide.button}
                </button>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {/* Custom CSS */}
      <style jsx>{`
        .custom-dots {
          bottom: 20px !important;
        }
        .custom-dots li button:before {
          color: white !important;
          opacity: 0.5;
          font-size: 10px;
        }
        .custom-dots li.slick-active button:before {
          color: white !important;
          opacity: 1;
        }
        @media (max-width: 768px) {
          .custom-dots {
            bottom: 10px !important;
          }
        }
        .slick-slide {
          height: 100% !important; /* Forces height consistency */
          overflow: hidden; /* Prevents content spill */
        }
        .slick-track {
          display: flex !important; /* Fix layout shifting */
          align-items: center;
        }
      `}</style>
    </div>
  );
};

export default BannerCarousel;
